var _desc, _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgQuote(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "45px",
    height: "39px",
    viewBox: "0 0 45 39",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\u201C") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Holding",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "10-2-holding-about",
    transform: "translate(-698.000000, -1970.000000)",
    fill: "#0061ED"
  }, /*#__PURE__*/React.createElement("g", {
    id: "quote",
    transform: "translate(403.000000, 1970.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-56"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-12"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M311.65,38.7 L295,38.7 L295,22.05 C295,19.049985 295.324997,16.2250132 295.975,13.575 C296.625003,10.9249867 297.624993,8.60001 298.975,6.6 C300.325007,4.59999 302.04999,3.000006 304.15,1.8 C306.250011,0.599994 308.699986,0 311.5,0 L311.5,7.5 C309.799992,7.5 308.400006,7.92499575 307.3,8.775 C306.199995,9.62500425 305.300004,10.749993 304.6,12.15 C303.899997,13.550007 303.425001,15.1249913 303.175,16.875 C302.924999,18.6250088 302.8,20.3499915 302.8,22.05 L311.65,22.05 L311.65,38.7 Z M339.1,38.7 L322.45,38.7 L322.45,22.05 C322.45,19.049985 322.774997,16.2250132 323.425,13.575 C324.075003,10.9249867 325.074993,8.60001 326.425,6.6 C327.775007,4.59999 329.49999,3.000006 331.6,1.8 C333.700011,0.599994 336.149986,0 338.95,0 L338.95,7.5 C337.249992,7.5 335.850006,7.92499575 334.75,8.775 C333.649995,9.62500425 332.750004,10.749993 332.05,12.15 C331.349997,13.550007 330.875001,15.1249913 330.625,16.875 C330.374999,18.6250088 330.25,20.3499915 330.25,22.05 L339.1,22.05 L339.1,38.7 Z",
    id: "\\u201C"
  }))))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuote);
export default ForwardRef;